import "index.scss";
import "syntax-highlighting.css";

import Animator from "./animator";

// Import all JavaScript & CSS files from src/_components
const componentsContext = require.context("bridgetownComponents", true, /\.(js|css)$/);
componentsContext.keys().forEach(componentsContext);

function onReady(completed) {
  if (document.readyState === "complete") {
    setTimeout(completed);
  } else {
    document.addEventListener("DOMContentLoaded", completed, false);
  }
}

// https://stackoverflow.com/a/44779316
function bindRequestAnimationFrame(callback, throttle) {
  let isRunning;
  let that;
  let args;

  const run = () => {
    isRunning = false;

    callback.apply(that, args);
  };

  return function() {
    that = this;
    args = arguments;

    if (isRunning && throttle) {
      return;
    }

    isRunning = true;

    window.requestAnimationFrame(run);
  };
}

onReady(() => {
  const animatorConfig = {
    "animations": [
      // TODO: JUST AN IDEA. NOT SURE ABOUT THIS ANYMORE. MIGHT BE MORE EFFORT
      // THAN IT'S WORTH. THE PROBLEM IS EXPRESSING ALL OF THE THINGS NECESSARY
      // FOR TRANSFORM ANIMATIONS. IT'S JUST TOO AWKWARD AND WILL REQUIRE TOO
      // MUCH ABSTRACTION TO MAKE IT WORK. WHAT I HAVE RIGHT NOW WORKS EVEN IF
      // IT'S LIMITED IN TERMS OF FLEXIBILITY. MAYBE I SHOULD LEAVE IT AS IS
      // SINCE THERE ARE A LIMITED NUMBER OF ANIMATIONS USED ON THIS SITE. IF
      // I WAS GOING TO PULL THIS OUT INTO A GENERAL PURPOSE ANIMATION LIBRARY
      // THEN SURE DOING ALL THE ABSTRACTION WOULD MAKE SENSE. BUT RIGHT NOW
      // WHAT I'VE GOT IS FINE ACTUALLY.
      // STILL WANT TO FIGURE OUT A WAY TO EXPRESS THE DIFFERENT "COMPONENTS"
      // OF AN ANIMATION. ALSO STILL NEED TO FIGURE OUT HOW TO EXPRESS MULTIPLE
      // ANIMATIONS AFFECTING THE TRANSFORM STYLE ON AN ELEMENT. I NEED SOME
      // WAY TO COMBINE THE DIFFERENT PARTS (TRANSLATE, SCALE, ROTATE, SKEW)
      // TOGETHER. BUT EACH ONE HAS X, Y, AND Z VALUES. WHICH IS FINE. BUT NOT
      // ALL ANIAMTIONS ARE THAT COMPLICATED. OPACITY IS JUST ONE VALUE FOR
      // EXAMPLE. THIS MEANS I WOULD NEED TO EITHER ADD AN UNNECESSARY LAYER
      // IN THE CONFIG FOR THOSE ANIMATONS (SEE "components" BELOW), IN THE
      // EXAMPLE OF OPACITY IT WOULD LOOK LIKE THIS:
      // {
      //   "element": document.querySelector(".navbar-component"),
      //   "type": "STYLE_TRANSFORM_OPACITY",
      //   "components": {
      //     "opacity": {
      //       ...
      // NOTE THE REDUNDENCY. OPACITY DOESN'T HAVE COMPONENTS. IT'S JUST A
      // SCALAR VALUE.
      // AFTER A LITTLE MORE THOUGHT MAYBE IT'S OKAY. THE "opacity" KEY SIMPLY
      // INDICATES THE NAME OF THE KEY THAT WILL BE SENT TO THE STYLE RENDER
      // FUNCTION. WE NEED TO GIVE THEM NAMES BECAUSE THE RENDER FUNCTION WILL
      // HAVE A switch THAT CALLS A DIFFERENT FUNCTION FOR EACH TYPE OF
      // ANIMATION.
      //
      // {
      //   "element": document.querySelector(".navbar-component"),
      //   "type": "STYLE_TRANSFORM_TRANSLATE",
      //   "components (awful name for this)": {
      //     "x": {
      //       "limit": {
      //         "limitType": "WINDOW_SCROLL_POSIITION",
      //         "scrollYmin": 145,
      //         "scrollYmax": 171,
      //         "scrollYUnits": "px"
      //       },
      //       "startValue": 0,
      //       "endValue": -6,
      //       "valueUnits": "rem",
      //       "easing": {
      //         "easingType": "quartic",
      //         "coefficients": [12.418773644942, -0.256506261338, 0.001603207595, -0.000003267928],
      //         "intercept": 148.704136846271
      //       }
      //     }
      //   }
      // },
      {
        "element": document.querySelector(".navbar-component"),
        "property": "transform",
        "styleFn": ({ translateY } = {}) => (`translate3d(0px, ${translateY}rem, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg)`),
        "curves": {
          "translateY": {
            "startY": 145,
            "endY": 171,
            "startValue": 0,
            "endValue": -6,
            "coefficients": [12.418773644942, -0.256506261338, 0.001603207595, -0.000003267928],
            "intercept": 148.704136846271
          }
        }
      },
      {
        "element": document.querySelector(".hero-image"),
        "property": "transform",
        "styleFn": ({ translateY, scaleY } = {}) => (`translate3d(0vw, ${translateY}vw, 0px) scale3d(1, ${scaleY}, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg)`),
        "curves": {
          "translateY": {
            "startY": 3,
            "endY": 192,
            "startValue": 0,
            "endValue": -7.9,
            "coefficients": [-0.041395796810],
            "intercept": 0.080556074406
          },
          "scaleY": {
            "startY": 3,
            "endY": 192,
            "startValue": 1,
            "endValue": 0.2,
            "coefficients": [-0.004191979424],
            "intercept": 1.008157577155
          }
        }
      },
      {
        "element": document.querySelector(".bungo-logo-hero"),
        "property": "transform",
        "styleFn": ({ translateX, translateY, scaleX, scaleY } = {}) => (`translate3d(${translateX}%, ${translateY}px, 0px) scale3d(${scaleX}, ${scaleY}, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg)`),
        "curves": {
          "translateX": {
            "startY": 3,
            "endY": 192,
            "startValue": 0,
            "endValue": -43.2,
            "coefficients": [-0.226366888886],
            "intercept": 0.440509166373
          },
          "translateY": {
            "startY": 3,
            "endY": 192,
            "startValue": 0,
            "endValue": -1,
            "coefficients": [-0.005239974280],
            "intercept": 0.010196971444
          },
          "scaleX": {
            "startY": 3,
            "endY": 192,
            "startValue": 1,
            "endValue": 0.134409,
            "coefficients": [-0.004535676541],
            "intercept": 1.008826415907
          },
          "scaleY": {
            "startY": 3,
            "endY": 192,
            "startValue": 1,
            "endValue": 0.634409,
            "coefficients": [-0.001915689081],
            "intercept": 1.003727909358
          }
        }
      },
      {
        "element": document.querySelector(".bungo-logo-hero"),
        "property": "opacity",
        "styleFn": ({ opacity } = {}) => (opacity.toString()),
        "curves": {
          "opacity": {
            "startY": 215,
            "endY": 320,
            "startValue": 1,
            "endValue": 0,
            "coefficients": [-0.009406718302],
            "intercept": 3.017574923547
          }
        }
      },
      {
        "element": document.querySelector(".sticky-progress-bar"),
        "property": "transform",
        "styleFn": (({ scaleX } = {}) => `translate3d(0px, 0px, 0px) scale3d(${scaleX}, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg)`),
        "curves": {
          "scaleX": {
            "startY": 550,
            "endY": 4300,
            "startValue": 1,
            "endValue": 1,
            "coefficients": [0.000251680011],
            "intercept": 0
          }
        }
      },
      {
        "element": document.querySelector(".image-padding"),
        "property": "transform",
        "styleFn": (({ scaleX, scaleY } = {}) => `translate3d(0px, 0px, 0px) scale3d(${scaleX}, ${scaleY}, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg)`),
        "curves": {
          "scaleX": {
            "startY": 268,
            "endY": 1170,
            "startValue": 1,
            "endValue": 1.25,
            "coefficients": [0.000213887299],
            "intercept": 0.942760959294
          },
          "scaleY": {
            "startY": 268,
            "endY": 1170,
            "startValue": 1,
            "endValue": 1.475,
            "coefficients": [0.000406385951],
            "intercept": 0.891246300526
          }
        }
      }
    ]
  };

  const animator = new Animator(animatorConfig);

  const updateAnimatedStyles = (scrollEvent) => {
    animator.animate(scrollEvent);
  };

  window.addEventListener("scroll", (event) => {
    bindRequestAnimationFrame(updateAnimatedStyles)(event);
  }, false);

  // TODO: I LIKE THIS IDEA BUT I REALLY NEED TO REVIST THE IMAGES IF I'M GOING
  // DO IT. THEY ALL NEED TO BE CLOSE TO THE SAME ASPECT RATIO (EXACTLY THE
  // SAME PREFERABLY) WITH A SKY BLUE AT THE TOP AND WITH ENOUGH CONTRAST FOR
  // WHITE TEXT.
  // CONSIDER MAKING A SOLID GREY PNG TO USE AS A PLACEHOLDER.
  // const heroImage = document.querySelector(".sticky-image img");

  // if (heroImage) {
  //   const heroImages = ["images/img001.jpg", "images/img002.jpg", "images/img003.jpg", "images/img004.jpg", "images/img005.jpg"];

  //   const randomImage = heroImages[Math.floor(Math.random() * heroImages.length)];

  //   heroImage.src = randomImage;
  // }
});
